import { Alert, AlertSeverity } from 'omakase';
import { FC } from 'react';
import { TOCK_DIRECT_BRAND_PHONE_NUMBER } from 'components/modal/SmsSubscribeConfirmationModal';

interface SmsAlertStoppedProps {
  severity?: AlertSeverity;
}

export const SmsAlertStopped: FC<SmsAlertStoppedProps> = ({ severity = 'info' }) => {
  return (
    <Alert
      severity={severity}
      heading="You previously opted out of text alerts."
      data-testid="sms-alert-stopped"
    >
      To receive text communications from Tock again, text START to {TOCK_DIRECT_BRAND_PHONE_NUMBER}
    </Alert>
  );
};
